export default "__VITE_ASSET__1c4d1d7b__"